import React from "react";
import Navbar from "../widgets/Navbar";
import Footer from "../widgets/Footer";

const PrivacyPolicy = () => {
  return (
    <div>
      <Navbar />
        <section className="in_page p70 bg4">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7">
              <h1 className="hadding">Privacy Policy</h1>
              <p>Dyntech (“we,” “us,” “our”) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your personal information in connection with our financial technology services.</p>
            </div>
            <div className="col-md-4 m-auto">
              <img
                src="/img/privacy-policy.png"
                alt="Privacy Policy"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="in_page p70 bg2">
        <div className="container">
          <h4 className="mb-3"><b>Information We Collect</b></h4>
         
          <ul className="list mb-4 mb-md-5">
            <li><b>Account Information:</b>   Name, email, phone number, address, date of birth.</li> 
            <li><b>Identification Documents: </b>  Government-issued IDs, proof of residence (for KYC/AML compliance).</li> 
            <li><b>Usage Data: </b>  Login timestamps, IP addresses, device information, API request logs. </li> 
            <li><b>Transactional Data: </b>  Order history, balances, deposit/withdrawal records. </li> 
          </ul>
          
           <h4 className="mb-3"><b>Important Notices</b></h4>
           <div className="row">
           <div className="col-md-6">
           <div className="table-responsive">
           <table className="table  table-condensed ">
            <tr>
              <th>Purpose</th>
              <th>Data Used</th>
            </tr>
             <tr>
              <td>Service Delivery</td>
              <td>Account & usage data</td>
            </tr>
              <tr>
              <td>Compliance (KYC/AML)</td>
              <td>ID documents & transactional data</td>
            </tr>
              <tr>
              <td>Platform Improvement</td>
              <td>Usage analytics & feedback</td>
            </tr>
              <tr>
              <td>Marketing & Communications</td>
              <td>Email address & preferences</td>
            </tr>
              <tr>
              <td>Fraud Prevention & Security </td>
              <td>IP logs & transaction patterns</td>
            </tr> 

           </table>
</div>
</div>
</div>

          <h4 className="mb-3 mt-md-5"><b>Data Sharing & Disclosure</b></h4>
           
<ul className="list">
   <li><b>Service Providers: </b> Cloud hosts, payment processors, and analytics vendors - under strict confidentiality agreements. </li> 
   <li><b> Regulatory & Legal Requests:</b> When required by law or valid subpoenas/regulatory inquiries. </li> 
    <li><b> With Your Consent:</b>  For co-marketing or third-party integrations you authorize.</li> 
          </ul> 
          
  </div>
      </section>
 <section className="in_page p70 ">
        <div className="container">
        <h4 className="mb-3"><b>Data Security</b></h4>
         <p>We implement industry-standard controls: AES-256 encryption at rest, TLS 1.2+ in transit, SOC 2 compliance, and regular third-party security audits.</p>  

             <h4 className="mb-3 mt-md-5"><b>Your Rights</b></h4>
         <p>Under applicable data protection laws (e.g., GDPR, CCPA), you may:</p>  

          <ul className="list">
            <li>Access and port your personal data.  </li> 
            <li> Request correction or deletion.</li> 
            <li> Restrict or object to processing.</li> 
            <li> Withdraw consent for marketing communications. </li> 
          </ul> 
          <p>To exercise any rights, contact: privacy@dyntech.com.</p>
          
          <h4 className=" mt-4 mt-md-5 mb-3"><b>Updates to This Policy</b></h4> 
          <p>
          We may revise this policy; the “Last Updated” date at the top reflects the current version. Significant changes will be communicated via email and on our platform.    </p>
       
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
